import { z } from 'zod';

/** BR-SO-235 — only items marked Attention/Do with a chosen part are sent. */
export const ApplyMaintenanceChecklistSelectionSchema = z.object({
  catalogGenericProductId: z.uuid(),
  itemId: z.uuid(),
  quantity: z.number().int().positive().optional(),
});

/**
 * Vehicle and place fields are accepted for parity with the revision plan apply body; the
 * checklist scope is always the place of the quote/service order.
 */
export const ApplyMaintenanceChecklistBodySchema = z.object({
  maintenanceChecklistId: z.uuid(),
  selections: z.array(ApplyMaintenanceChecklistSelectionSchema),
  vehicleModelId: z.uuid().optional(),
  manufactureYear: z.number().int().min(1900).max(2100).optional(),
  vehicleEngineId: z.uuid().optional(),
  placeId: z.uuid().optional(),
  assignedMechanicUserId: z.uuid().optional(),
});

export const ApplyMaintenanceChecklistResponseSchema = z.object({
  addedItemIds: z.array(z.uuid()),
});

export type ApplyMaintenanceChecklistSelection = z.infer<
  typeof ApplyMaintenanceChecklistSelectionSchema
>;
export type ApplyMaintenanceChecklistBody = z.infer<typeof ApplyMaintenanceChecklistBodySchema>;
export type ApplyMaintenanceChecklistResponse = z.infer<
  typeof ApplyMaintenanceChecklistResponseSchema
>;
